import { computeGroupSum } from "@patient-watch/forms/pageValidation";
import { type Control, useWatch } from "react-hook-form";

import { useEntryValuesStore } from "../../inputs/hooks/useEntryValuesStore";
import { buildAnswerMapFromEntryValues } from "./useFormBranchingNavigation";

/**
 * The running total of a group of inputs that must add up to a fixed number. Answers given on this page
 * come from the form, and answers on earlier pages from the saved entry values. A blank counts as 0.
 */
export function useGroupSum(inputIds: string[], target: number, control: Control<Record<string, unknown>>): number {
    const values = useWatch({ control, name: inputIds });
    const entryValues = useEntryValuesStore((state) => state.entry_values);
    const earlier = buildAnswerMapFromEntryValues(entryValues);
    return computeGroupSum(
        { type: "sum_equals", input_ids: inputIds, total: target },
        Object.fromEntries(inputIds.map((id, index) => [id, values[index] ?? earlier[id]]))
    );
}
